<ng-container [formGroup]="form">
    <p-fieldset legend="BASIC INFORMATION">
        <div class="grid p-fluid">
            <div class="col-6">
                <m-control-group [required]="true" label="Title">
                    <m-title-control formControlName="title"></m-title-control>
                    <control-errors [control]="form.get('title')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="First Name">
                    <m-text-control formControlName="firstName"></m-text-control>
                    <control-errors [control]="form.get('firstName')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Last Name">
                    <m-text-control formControlName="lastName"></m-text-control>
                    <control-errors [control]="form.get('lastName')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Date of Birth">
                    <m-dob-control formControlName="dateOfBirth"></m-dob-control>
                    <control-errors [control]="form.get('dateOfBirth')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Sex">
                    <m-gender-control formControlName="gender"></m-gender-control>
                    <control-errors [control]="form.get('gender')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Phone No.">
                    <m-text-control formControlName="phoneNumber"></m-text-control>
                    <control-errors
                        [control]="form.get('phoneNumber')"
                        [errors]="{ pattern: 'The phone number is invalid' }"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Email Address">
                    <m-email-control formControlName="email"></m-email-control>
                    <control-errors
                        [control]="form.get('email')"
                        [errors]="{
                            pattern: 'The email is invalid',
                            emailMaxLength: 'The email cannot exceed {emailMaxLength} characters'
                        }"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group [required]="true" label="Professional Reg No">
                    <m-text-control formControlName="registrationNumber"></m-text-control>
                    <control-errors [control]="form.get('registrationNumber')"></control-errors>
                </m-control-group>
            </div>
        </div>
    </p-fieldset>

    <p-fieldset legend="ADDRESS DETAILS">
        <div class="grid p-fluid">
            <div class="col-6">
                <m-control-group label="Address Line 1">
                    <m-text-control formControlName="addressLine1"></m-text-control>
                    <control-errors [control]="form.get('addressLine1')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Address Line 2">
                    <m-text-control formControlName="addressLine2"></m-text-control>
                    <control-errors [control]="form.get('addressLine2')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Address Line 3">
                    <m-text-control formControlName="addressLine3"></m-text-control>
                    <control-errors [control]="form.get('addressLine3')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Address Line 4">
                    <m-text-control formControlName="addressLine4"></m-text-control>
                    <control-errors [control]="form.get('addressLine4')"></control-errors>
                </m-control-group>
            </div>
            <div class="col-6">
                <m-control-group label="Post Code">
                    <m-text-control formControlName="postcode"></m-text-control>
                    <control-errors [control]="form.get('postcode')"></control-errors>
                </m-control-group>
            </div>
        </div>
    </p-fieldset>
</ng-container>

<p-fieldset *ngIf="showOtherInformation" legend="OTHER INFORMATION">
    <div class="grid p-fluid">
        <ng-content></ng-content>
    </div>
</p-fieldset>
